import { Pipe, PipeTransform } from '@angular/core'
import { DeviceComponentType } from '@wm-front/shared/enums'

@Pipe({
  name: 'deviceComponentType',
  standalone: true,
})
export class DeviceComponentTypePipe implements PipeTransform {
  /** Transform device component type into localised string
   * @returns { string }
   * @param value
   */
  public transform(value: DeviceComponentType): string {
    switch (value?.trim()) {
      case DeviceComponentType.Car:
        return $localize`:Label | Value for the device component type car@@deviceComponentTypeCarLabel:Cabine`
      case DeviceComponentType.Doors:
        return $localize`:Label | Value for the device component type doors@@deviceComponentTypeDoorsLabel:Portes`
      case DeviceComponentType.Landings:
        return $localize`:Label | Value for the device component type landings@@deviceComponentTypeLandingsLabel:Palier`
      case DeviceComponentType.Machinery:
        return $localize`:Label | Value for the device component type machinery@@deviceComponentTypeMachineryLabel:Machinerie`
      case DeviceComponentType.ShaftPit:
        return $localize`:Label | Value for the device component type shaft pit@@deviceComponentTypeShaftPitLabel:Fonds de fosse`
      case DeviceComponentType.Shaft:
        return $localize`:Label | Value for the device component type shaft@@deviceComponentTypeShaftLabel:Gaine`
      case DeviceComponentType.Pulleys:
        return $localize`:Label | Value for the device component type pulleys@@deviceComponentTypePulleysLabel:Poulies`
      case DeviceComponentType.TopOfCar:
        return $localize`:Label | Value for the device component type top of car@@deviceComponentTypeTopOfCarLabel:Toit de cabine`
      case DeviceComponentType.Parachute:
        return $localize`:Label | Value for the device component type parachute@@deviceComponentTypeParachuteLabel:Parachute`
      case DeviceComponentType.TractionCable:
        return $localize`:Label | Value for the device component type parachute@@deviceComponentTypeTractionCableLabel:Cable`
      case DeviceComponentType.Controller:
        return $localize`:Label | Value for the device component type controller@@deviceComponentTypeControllerLabel:Système de contrôle`
      case DeviceComponentType.MotorRoom:
        return $localize`:Label | Value for the device component type motor room@@deviceComponentTypeMotorRoomLabel:Salle des machines`
      case DeviceComponentType.Incline:
        return $localize`:Label | Value for the device component type incline@@deviceComponentTypeInclineLabel:Inclinaison`
      case DeviceComponentType.LowerLanding:
        return $localize`:Label | Value for the device component type lower landing@@deviceComponentTypeLowerLandingLabel:Palier inférieur`
      case DeviceComponentType.UpperLanding:
        return $localize`:Label | Value for the device component type upper landing@@deviceComponentTypeUpperLandingLabel:Palier supérieur`
      case DeviceComponentType.Multiple:
        return $localize`:Label | Value for the device component type multiple@@deviceComponentTypeMultipleLabel:Multiple`
      case DeviceComponentType.None:
        return $localize`:Label | Value for the device component type none@@deviceComponentTypeNoneLabel:NC`
      default:
        return $localize`:Label | Default value for the device component type@@deviceComponentTypeDefaultLabel:Autre`
    }
  }
}
